/** Persisted bases are SQL row snapshots, not generated protobuf messages. */ const row = (value)=>value !== null && typeof value === 'object' && !Array.isArray(value) ? value : null;
export function parseMappingJson(json) {
    try {
        return row(JSON.parse(json));
    } catch  {
        return null;
    }
}
export function parseMappingBasis(json) {
    const value = parseMappingJson(json);
    if (!value) return null;
    return {
        source: row(value.source),
        target: row(value.target),
        anchor: row(value.anchor),
        mapping_type: typeof value.mapping_type === 'string' ? value.mapping_type : '',
        evidence: value.evidence,
        confidence: value.confidence,
        proposed_by: typeof value.proposed_by === 'string' ? value.proposed_by : '',
        provenance: typeof value.provenance === 'string' ? value.provenance : ''
    };
}
export function hasReviewEndpoints(basis) {
    const validEntry = (entry)=>!!entry && typeof entry.id === 'string' && entry.id.length > 0 && typeof entry.version === 'number' && entry.version > 0;
    return !!basis && validEntry(basis.source) && (basis.target && !basis.anchor ? validEntry(basis.target) : !basis.target && typeof basis.anchor?.id === 'string' && basis.anchor.id.length > 0);
}
export function affectedStaffingReferences(json) {
    const value = parseMappingJson(json)?.staffing_lines;
    if (!Array.isArray(value)) return [];
    return value.flatMap((item)=>{
        const ref = row(item);
        return ref && typeof ref.id === 'string' && typeof ref.program_id === 'string' && typeof ref.lcat_id === 'string' ? [
            {
                id: ref.id,
                program_id: ref.program_id,
                lcat_id: ref.lcat_id
            }
        ] : [];
    });
}
